/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import React from 'react';
import NextImage from '../../../components/NextImage';
import styles from './ContactUsModal.module.scss';
import cx from 'classnames';
import { Actionable } from '@az/starc-ui';

type Props = {
  id?: string;
  icon: {
    height: number;
    width: number;
    src: string;
  };
  title: string;
  subtext: string;
  isDisabled?: boolean;
  linkTo?: string;
  onClick?: () => void;
};

export function ContactUsOption({
  id,
  icon,
  title,
  subtext,
  linkTo,
  onClick,
  isDisabled = false,
}: Props) {
  return (
    <Actionable
      attributes={{ id }}
      href={linkTo}
      className={cx({ [styles.isDisabled]: isDisabled }, styles.contactUsOption)}
      onClick={onClick}
      aria-label={`${title} ${subtext}`}
    >
      <div className={styles.iconAndTitle}>
        <NextImage src={icon.src} height={icon.height} width={icon.width} />
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.subtext}>{subtext}</div>
    </Actionable>
  );
}
